<!--
/*******************************************************************************
*@ 컴포넌트명   : MnrcvTrsaccAmt.vue
*@ 컴포넌트설명 : 입금금액 컴포넌트
*@ 사용전문     : RBF0408A40 - FX환산금액산출
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <popup
    :opened.sync="openData"
    :use-footer="true"
    class="calculator-popup"
    :class="{ default: !isFcTranz }"
    :title="acnoInfo.drwotAcno ? acnoInfo.drwotAcno : ''"
    :btn-area-padding="false"
  >
    <template #content>
      <article class="description">
        <div class="breakdown">
          <ul class="breakdown-list">
            <li>
              <ul>
                <li>
                  <template v-if="pageOption != 'myQr'">
                    <div class="item basic" v-if="acnoInfo.drwotAbilAmt >= 0">
                      <div class="tit">{{ /*출금 가능 금액*/ $t("MPAY-01-01-08-02") }}</div>
                      <div class="desc">
                        <span class="exchange-unit">{{ infoValue.drwotCncycd }}</span>
                        <span class="amount">{{ $num(acnoInfo.drwotAbilAmt) }}</span>
                      </div>
                    </div>
                    <div class="item basic" v-if="acnoInfo.dailyTrsaccAcamtRmainLimt >= 0">
                      <div class="tit">{{ /*1일이체잔여한도*/ $t("MPAY-01-01-08-03") }}</div>
                      <div class="desc">
                        <span class="exchange-unit">{{ infoValue.drwotCncycd }}</span>
                        <span class="amount">{{ $num(acnoInfo.dailyTrsaccAcamtRmainLimt) }}</span>
                      </div>
                    </div>
                  </template>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </article>
      <article class="contents exchange-calculator">
        <!-- 동종통화 -->
        <div class="exchange box-white" :class="{ selected: fxTranz == '01' }" @click="setFxTranz('01')">
          <label v-if="pageOption == 'payment'" for="textfield1" class="form-label">{{ /*출금 금액*/ $t("MPAY-01-01-09-05") }}</label>
          <label v-else for="textfield1" class="form-label">{{ /*입금 금액*/ $t("MPAY-01-01-09-04") }}</label>
          <div v-if="fxTranz == '01'" class="calc-formula">{{ formula }}</div>
          <div class="input-text-field">
            <div class="nation">
              <span class="nation-name">{{ infoValue.mnrcvCncycd }}</span>
            </div>
            <div class="form-control">
              <i v-if="fxTranz == '01'" class="icon icon-del" @click="fnClear()"></i>
              <span>{{ fxTranz == "01" ? $utils().Converter.numberWithCommas(current) : fxTranzAmt > 0 ? $num(fxTranzAmt) : "" }}</span>
            </div>
          </div>
          <!-- 오류문구 -->
          <div v-if="minTrsaccAmtErrDstcd == '01' && isMinimunAmtErrorShow" class="min-amount">
            {{ /*금액은 {min}이상 입력하셔야 합니다.*/ $t("validations.amtMinValue", { min: minTrsaccAmt }) }}
          </div>
          <div v-if="fxTranz == '01' && isUsePointErrorShow" class="min-amount">{{ /*소수점 이하는 입력할 수 없습니다.*/ $t("MPAY-01-01-09-06") }}</div>
        </div>
        <!-- 이종통화 -->
        <div v-if="isFcTranz" class="exchange box-white" :class="{ selected: fxTranz == '02' }" @click="setFxTranz('02')">
          <label for="textfield1" class="form-label">{{ /*출금 금액*/ $t("MPAY-01-01-09-05") }}</label>
          <div v-if="fxTranz == '02'" class="calc-formula">{{ formula }}</div>
          <div class="input-text-field">
            <div class="nation">
              <span class="nation-name">{{ infoValue.drwotCncycd }}</span>
            </div>
            <div class="form-control">
              <i v-if="fxTranz == '02'" class="icon icon-del" @click="fnClear()"></i>
              <span>{{ fxTranz == "02" ? $utils().Converter.numberWithCommas(current) : fxTranzAmt > 0 ? $num(fxTranzAmt) : "" }}</span>
            </div>
          </div>
          <!-- 오류문구 -->
          <div v-if="minTrsaccAmtErrDstcd == '02' && isMinimunAmtErrorShow" class="min-amount">
            {{ /*금액은 {min}이상 입력하셔야 합니다.*/ $t("validations.amtMinValue", { min: minTrsaccAmt }) }}
          </div>
          <div v-if="fxTranz == '02' && isUsePointErrorShow" class="min-amount">{{ /*소수점 이하는 입력할 수 없습니다.*/ $t("MPAY-01-01-09-06") }}</div>
        </div>
        <div class="calculator default" v-if="!isFcTranz">
          <table>
            <tbody>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('1')">1</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('2')">2</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('3')">3</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('4')">4</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('5')">5</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('6')">6</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('7')">7</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('8')">8</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('9')">9</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('.')">.</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('0')">0</span>
                </td>
                <td>
                  <span class="btn back-del" @click="fnDel()"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="calculator" v-else>
          <table>
            <tbody>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('7')">7</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('8')">8</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('9')">9</span>
                </td>
                <td>
                  <span class="btn back-del" @click="fnDel()"></span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('4')">4</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('5')">5</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('6')">6</span>
                </td>
                <td>
                  <span class="btn minus" @click="fnSub()"></span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('1')">1</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('2')">2</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('3')">3</span>
                </td>
                <td>
                  <span class="btn plus" @click="fnAdd()"></span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="num" @click="fnAppend('00')">00</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('0')">0</span>
                </td>
                <td>
                  <span class="num" @click="fnAppend('.')">.</span>
                </td>
                <td>
                  <span class="btn inequality" @click="fnCal()"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>
    </template>
    <template #footer>
      <button :class="`btn bottom ${isBtnEnable ? `positive` : `disabled`}`" @click="fnEnter()">{{ /*입력완료*/ $t("MPAY-01-01-09-07") }}</button>
    </template>
  </popup>
</template>
<script>
import { mnrcvTrsaccCheck } from "@/mixins/transfer";
import { mapFields } from "vuex-map-fields";

export default {
  name: "MnrcvTrsaccAmt",
  mixins: [mnrcvTrsaccCheck],
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {
          fxTranz: "01", // FX환산 (01: 입금->출금금액 환산, 02: 출금->입금금액 환산)
          drwotCncycd: "", //출금계좌 통화코드
          mnrcvCncycd: "", // 입금계좌 통화코드
          drwotAmt: "", //출금금액
          mnrcvAmt: "", //입금금액
        };
      },
    },
    acnoInfo: {
      type: Object,
      default: () => {
        return {
          drwotAcno: "", //출금계좌번호
          drwotAbilAmt: 0, //출금가능금액
          dailyTrsaccAcamtRmainLimt: 0, // 1일이체잔여한도
        };
      },
    },
    page: {
      type: String,
      default: "transfer", //transfer: 즉시이체, otrbnk: 타행이체, ovses: 해외송금
    },
    pageOption: {
      // napasQR 분기처리
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fxTranz: "01", // FX환산 (01: 입금->출금금액 환산, 02: 출금->입금금액 환산)
      current: "", // 입력금액
      fxTranzAmt: "", // FX환산금액
      minTrsaccAmt: 0, // 최소이체금액
      minTrsaccAmtErrDstcd: "01", //최소 이체금액 오류 구분 (표기 위치)
      isOperator: false,
      isBtnEnable: true,
      isFcTranz: false, // 외화거래 여부 (true=외화)
      formula: "",
      formulas: [],
      isUsePoint: true, //소수점 입력 가능 여부
      isUsePointErrorShow: false, //소수점 입력 오류 메시지 노출여부
      isMinimunAmtErrorShow: false, //최소 금액 입력 오류 메시지 노출여부
    };
  },
  computed: {
    ...mapFields(["sessionInfo", "siteCode", "popupOpen"]),
    infoValue: {
      get() {
        return this.info;
      },
      set(value) {
        this.$emit("update:info", value);
      },
    },
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fxTranzAmt = "";
      this.formula = "";
      this.formulas = [];
      this.isOperator = false;

      if (this.info.fxTranz) this.fxTranz = this.info.fxTranz;

      //캄보디아, 베트남, 미얀마 USD 통화 외 수정 불가
      if (this.page == "transfer" && this.infoValue.mnrcvCncycd != this.infoValue.drwotCncycd) {
        if (this.siteCode == this.$config.SITECODE_OGCBD || this.siteCode == this.$config.SITECODE_OGHCM || this.siteCode == this.$config.SITECODE_OGMMR) {
          if (this.infoValue.mnrcvCncycd == "USD") {
            this.fxTranz = "01";
          } else if (this.infoValue.drwotCncycd == "USD") {
            this.fxTranz = "02";
          }
        }
      }

      if (this.fxTranz == "01") {
        this.current = this.info.mnrcvAmt == "" || this.info.mnrcvAmt == null ? "0" : String(this.info.mnrcvAmt);
        this.$set(this.infoValue, "mnrcvCncycd", this.info.mnrcvCncycd == "" || this.info.mnrcvCncycd == null ? this.info.drwotCncycd : this.info.mnrcvCncycd);
        // this.infoValue.mnrcvCncycd = this.info.mnrcvCncycd == "" || this.info.mnrcvCncycd == null ? this.info.drwotCncycd : this.info.mnrcvCncycd;
      } else {
        this.current = this.info.drwotAmt == "" || this.info.drwotAmt == null ? "0" : String(this.info.drwotAmt);
        // this.infoValue.drwotCncycd = this.info.drwotCncycd == "" || this.info.drwotCncycd == null ? this.info.mnrcvCncycd : this.info.drwotCncycd;
        this.$set(this.infoValue, "drwotCncycd", this.info.drwotCncycd == "" || this.info.drwotCncycd == null ? this.info.mnrcvCncycd : this.info.drwotCncycd);
      }

      if (this.page == "ovses" && this.siteCode != this.$config.SITECODE_OGAUC && this.siteCode != this.$config.SITECODE_OGHCM) {
        this.isFcTranz = false;
      } else {
        this.isFcTranz = this.infoValue.drwotCncycd != this.infoValue.mnrcvCncycd ? true : false;
      }
      this.isBtnEnable = this.isFcTranz ? false : true;

      //소수점 입력 가능여부 체크
      this.isUsePointErrorShow = false;
      this.isUsePoint = this.getAmtPointCheck(this.fxTranz, this.info.mnrcvCncycd, this.info.drwotCncycd);
      //최소 이체 금액
      this.isMinimunAmtErrorShow = false;
      this.minTrsaccAmt = this.getMinTrsaccAmt(this.fxTranz, this.info.mnrcvCncycd, this.info.drwotCncycd, this.page);
    },
    fnAppend(val) {
      var numValue = "" + val;

      if (numValue == "" || numValue == null) return;

      if (this.isOperator) {
        this.isOperator = false;
        this.current = "0";
      }

      // 자릿수 체크
      if (/^(\d*)[.](\d{2})$/g.test(this.current) || (numValue != "." && /^(\d{13})$/g.test(this.current))) {
        return;
      }

      if (numValue == "00" && (/^(\d*)[.](\d{1})$/g.test(this.current) || /^(\d{12})$/g.test(this.current))) numValue = "0";

      //소수점 오류 메시지 hide
      this.isUsePointErrorShow = false;
      this.isMinimunAmtErrorShow = false;

      // 키패드 입력
      switch (numValue) {
        case ".":
          //소수점 입력가능 여부 체크
          if (!this.isUsePoint) {
            //소수점 오류 메시지 show
            this.isUsePointErrorShow = true;
          } else {
            if (this.current.toString().indexOf(".") < 1) this.current = `${this.current}${numValue}`;
          }
          break;
        case "0":
        case "00":
          if (Number(this.current) > 0 || this.current.toString() == "0.") this.current = `${this.current}${numValue}`;
          break;
        default:
          // 숫자 키패드 입력
          if (this.current.toString().indexOf(".") < 1 && Number(this.current, 0) === 0) {
            this.current = numValue;
          } else {
            this.current = `${this.current}${numValue}`;
          }
          break;
      }

      this.fxTranzAmt = "";
      this.setBtnEnable();
    },
    fnDel() {
      this.isUsePointErrorShow = false;

      var numValue = "" + this.current;

      if (numValue === "0") return;
      this.current = numValue.length > 1 ? numValue.substring(0, numValue.length - 1) : "0";

      this.setBtnEnable();
    },
    fnAdd() {
      this.setOperator("+");
    },
    fnSub() {
      this.setOperator("-");
    },
    fnCal() {
      let temp = 0;

      if (this.isOperator && this.current != 0) this.formulas.splice(this.formulas.length - 1, 1);

      this.formulas.push(this.current);
      temp = Number(eval(this.formulas.join("")).toFixed(2));

      // 계산 결과 화면 표기
      if (this.formulas.length > 1) {
        this.formulas.push("=");
        this.formulas.push(temp);
      }

      this.formula = this.getFormula();

      if (temp > 0) {
        this.current = temp + "";
      } else {
        this.current = "0";
      }

      this.formulas = [];
      this.isOperator = false;

      if (this.isFcTranz) {
        this.RBF0408A40Call();
      } else {
        let rtn = this.checkMinimunAmt(temp);

        if (rtn) {
          //최소값 미만인 경우
          this.isBtnEnable = false;
        } else {
          if (this.current > 0) {
            this.isBtnEnable = true;
          }
        }
      }
    },
    fnClear() {
      this.current = "0";
      this.fxTranzAmt = "";
      this.formula = "";
      this.formulas = [];
      this.isOperator = false;
      this.isBtnEnable = false;
      this.isUsePointErrorShow = false;
      this.isMinimunAmtErrorShow = false;
    },
    setOperator(val) {
      if (this.formulas.length < 1 && this.current == "0") {
        return;
      }

      if (this.isOperator) {
        this.formulas.splice(this.formulas.length - 1, 1);
      } else {
        this.formulas.push(parseFloat(this.current));
      }

      this.fxTranzAmt = "";
      this.isOperator = true;

      if (this.formulas.length > 2) {
        this.fnCal();

        this.formulas.push(this.current);
        this.isOperator = true;
      } else {
        this.isBtnEnable = false;
      }

      this.current = "0";

      this.formulas.push(val);
      this.formula = this.getFormula();
    },
    fnEnter() {
      this.isUsePointErrorShow = false;
      this.isMinimunAmtErrorShow = false;

      if (this.isFcTranz) {
        if (this.fxTranzAmt == "" || this.fxTranzAmt == null) {
          this.fnCal();
        }
      } else {
        this.fnCal();
        this.fxTranzAmt = this.current;

        if (!this.isBtnEnable) return;
      }

      this.RBF0405U40Call();
    },
    getFormula() {
      let temp = "";
      for (const v of this.formulas) {
        temp = temp + " " + (Number(v, "0") ? this.$utils().Converter.numberWithCommas(v) : v);
      }
      return temp;
    },
    setFxTranz(data) {
      if (data == this.fxTranz) return;

      //2차 타행이체(otrbnk) 추가 예정
      if (data == "02" && this.page != "transfer") return;

      //캄보디아, 베트남, 미얀마 USD 통화 외 수정 불가
      if (
        this.infoValue.mnrcvCncycd != this.infoValue.drwotCncycd &&
        (this.infoValue.mnrcvCncycd == "USD" || this.infoValue.drwotCncycd == "USD") &&
        (this.siteCode == this.$config.SITECODE_OGCBD || this.siteCode == this.$config.SITECODE_OGHCM || this.siteCode == this.$config.SITECODE_OGMMR)
      )
        return;

      this.fxTranz = data;
      this.fnClear();

      //소수점 입력 가능여부 체크
      this.isUsePoint = this.getAmtPointCheck(this.fxTranz, this.info.mnrcvCncycd, this.info.drwotCncycd);
      //최소 이체 금액
      this.minTrsaccAmt = this.getMinTrsaccAmt(this.fxTranz, this.info.mnrcvCncycd, this.info.drwotCncycd, this.page);
    },
    setBtnEnable() {
      if (!this.isFcTranz && this.formulas.length <= 1) {
        if (!this.isMinimunAmtErrorShow) this.isBtnEnable = true;
      } else {
        this.isBtnEnable = false;
      }
    },
    RBF0408A40Call() {
      let param;

      if (Number(this.current, "0") < 0) {
        this.fxTranzAmt = "";
        return;
      }

      let isEqualBaseCncycd = this._.isEqual(this.sessionInfo.userInfo.baseCncycd, this.infoValue.drwotCncycd);
      let targetTranAmt = false; //출금기준금액
      if (this.siteCode == this.$config.SITECODE_OGCBD) {
        //출금이 이체기준통화(USD) 일 경우
        if (isEqualBaseCncycd) targetTranAmt = true;
      } else if (this.siteCode == this.$config.SITECODE_OGHCM) {
        //외화이체로 출금계좌 USD만 선택 가능하기 때문에 고정
        if (this.fxTranz == "02") targetTranAmt = true;
      } else {
        if (this.fxTranz == "02") targetTranAmt = true;
      }
      param = {
        ovsesAplyExrtDstcd: this._.isEqual(this.sessionInfo.userInfo.baseCncycd, this.infoValue.drwotCncycd) ? "01" : "02",
        cncycd: this.infoValue.drwotCncycd,
        fxCncycd: this.infoValue.mnrcvCncycd,
        tranAmt: targetTranAmt ? this.current : 0,
        fxTranAmt: targetTranAmt ? 0 : this.current,
      };
      //동종통화
      // if (this.fxTranz == "01") {
      //   let ovsesAplyExrtDstcd = this._.isEqual(this.sessionInfo.userInfo.baseCncycd, this.infoValue.drwotCncycd) ? "01" : "02";

      //   param = {
      //     ovsesAplyExrtDstcd:  ovsesAplyExrtDstcd,
      //     cncycd: this.infoValue.drwotCncycd, //통화코드
      //     fxCncycd: this.infoValue.mnrcvCncycd, //상대통화코드
      //     tranAmt: this.current, //상대통화금액
      //   };

      // //이종통화
      // } else {
      //   let targetCncycd = this.infoValue.drwotCncycd;
      //   let isEqualBaseCncycd = this._.isEqual(this.sessionInfo.userInfo.baseCncycd, targetCncycd);
      //   if (this.siteCode == this.$config.SITECODE_OGHCM) {
      //     //베트남, USD 기준으로만 금액 입력 가능
      //     isEqualBaseCncycd = false;
      //   }

      //   param = {
      //     ovsesAplyExrtDstcd: isEqualBaseCncycd ? "01" : "02",
      //     cncycd: this.infoValue.mnrcvCncycd, //통화코드
      //     fxCncycd: this.infoValue.drwotCncycd, //상대통화코드
      //     tranAmt: this.current, //상대통화금액
      //   };
      // }

      this.$post("/transfer/mntacc/FcTrsaccAucInq", param, this.RBF0408A40Suc, this.RBF0408A40Fail);
    },
    RBF0408A40Suc(res) {
      this.fxTranzAmt = res.outItem.fxTranzAmt;

      let rtn = false;

      if (this.siteCode == this.$config.SITECODE_OGAUC) {
        if ((this.fxTranz == "01" && this.infoValue.drwotCncycd == "NZD") || (this.fxTranz == "02" && this.infoValue.mnrcvCncycd == "NZD")) {
          rtn = this.checkMinimunAmt(this.fxTranzAmt);
        } else {
          rtn = this.checkMinimunAmt(this.current);
        }
      } else {
        rtn = this.checkMinimunAmt(this.current);
      }

      if (this.fxTranzAmt > 0) {
        if (!rtn) this.isBtnEnable = true;
      }
    },
    RBF0408A40Fail() {
      this.fxTranzAmt = "";
    },
    RBF0405U40Call() {
      let untcTranDstcd = "";
      let untcLimtDstcd = "";

      /* BO비대면거래구분코드
      A: 즉시이체, 외화이체
      B: 타행이체
      D: 해외송금*/

      if (this.page == "transfer") {
        //즉시이체(A), 외화이체(B)
        untcTranDstcd = "A";
      } else if (this.page == "otrbnk" || this.page == "cbmnet") {
        //타행이체(B)
        untcTranDstcd = "B";
        
        // MMQR결제 타행이체 한도 조회 적용
        if (this.pageOption == "mmQr") {
          untcLimtDstcd = "B4";
        }
      } else if (this.page == "ovses") {
        //해외송금(D)
        untcTranDstcd = "D";
      } else if (this.page == "payment") {
        //베트남 QR결제는 무조건 타행이체 한도로 조회
        if (this.pageOption == "myQr") {
          untcTranDstcd = "P";
        } else {
          untcTranDstcd = "B";
        }
      }

      let tranAmtTmp = "";
      if (this.fxTranz == "01") {
        tranAmtTmp = this.fxTranzAmt; // 23.10.10 베트남과 오클랜드 출금가능금액 산출 거래시에도 환산금액 적용을 위해 조건문 삭제
      } else {
        tranAmtTmp = this.current;
      }
      let params = {
        acno: this.acnoInfo.drwotAcno, // 계좌번호
        cncycd: this.infoValue.drwotCncycd, // 통화코드
        tranAmt: tranAmtTmp, // 이체금액
        untcTranDstcd: untcTranDstcd,
        untcLimtDstcd: untcLimtDstcd, // MMQR:B3
      };

      this.$post("/transfer/mntacc/TrsaccLimitCheck", params, this.RBF0405U40Suc);
      this.$log.info({ RBF0405U40Call_params: params });
    },
    RBF0405U40Suc(res) {
      this.$log.info({ RBF0405U40Suc: res });
      this.infoValue.fxTranz = this.fxTranz;

      if (this.fxTranz == "01") {
        this.infoValue.mnrcvAmt = this.current;
        this.infoValue.drwotAmt =
          (this.siteCode == this.$config.SITECODE_OGAUC || this.siteCode == this.$config.SITECODE_OGHCM) && this.page == "ovses" ? this.current : this.fxTranzAmt;
      } else {
        this.infoValue.mnrcvAmt = this.fxTranzAmt;
        this.infoValue.drwotAmt = this.current;
      }

      this.openData = false;
      this.popupOpen = false;
    },
    checkMinimunAmt(amt) {
      if (Number(amt) < Number(this.minTrsaccAmt)) {
        this.isMinimunAmtErrorShow = true;

        if (this.infoValue.drwotCncycd != this.infoValue.mnrcvCncycd && this.siteCode == this.$config.SITECODE_OGAUC) {
          this.minTrsaccAmtErrDstcd = this.infoValue.drwotCncycd == "NZD" ? "02" : "01";
        } else {
          this.minTrsaccAmtErrDstcd = this.fxTranz;
        }
      }

      return this.isMinimunAmtErrorShow;
    },
  },
};
</script>
